var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.9775C5.39623 13.849 5.27894 13.7024 5.15086 13.5401C4.64097 12.894 3.96245 12.003 3.28522 11.0203C2.6064 10.0352 1.93758 8.9705 1.44095 7.97556C0.933252 6.95842 0.65 6.09967 0.65 5.5C0.65 2.82142 2.82142 0.65 5.5 0.65C8.17858 0.65 10.35 2.82142 10.35 5.5C10.35 6.09967 10.0667 6.95842 9.55905 7.97556C9.06242 8.9705 8.3936 10.0352 7.71478 11.0203C7.03755 12.003 6.35903 12.894 5.84914 13.5401C5.72106 13.7024 5.60377 13.849 5.5 13.9775Z",
    stroke: "#00A0AF",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d393cbd6209b51daa2d306b9d2a3c6ed.svg";
export { ForwardRef as ReactComponent };